module.exports = __webpack_public_path__ + "static/media/background_1.94136faf.jpg";